<template>
  <div>
    <div class="container">
      <loading :active.sync="isLoading" :is-full-page="true" color="#4e97b2"> </loading>
      <div class="row">
        <div class="col-lg-12 text-left">
          <BreadcrumbsHelper :breadcrumbs="this.Breadcrumbs" />
        </div>
        <!--end left col -->
        <div class="col-lg-12 text-right"></div>
        <!--end right col -->
      </div>
      <div class="row">
        <div class="col-lg-12">
          <b-card>
            <div class="active-alerts-section text-left">
              <div class="row">
                <div class="col-lg-6">
                  <h1>Active Alerts</h1>
                </div>
                <div class="col-lg-6 text-right">
                  <b-button id="newAlertBtn" class="btn btn-secondary" variant="outline-primary" @click="$router.push('alerts/create')">+ New Alert</b-button>
                </div>
              </div>
              <div class="text-center mb-2 sort-wrapper">
                <span>
                  Sorting By:
                  <b>{{ activeCurrentSort }}</b
                  >, Sort Direction:
                  <b>{{ activeCurrentSortDir }}</b>
                </span>
              </div>
              <div class="table-responsive">
                <table id="activeAlerts" class="table table-sm table-striped">
                  <thead>
                    <tr>
                      <th @click="sort('title', (type = 'active'))" class="sort">
                        <span>Title<font-awesome-icon icon="sort" /></span>
                      </th>
                      <th>Property</th>
                      <th @click="sort('level', (type = 'active'))" class="sort">
                        <span>Level<font-awesome-icon icon="sort" /></span>
                      </th>
                      <th @click="sort('expires', (type = 'active'))" class="sort">
                        <span>Expires<font-awesome-icon icon="sort" /></span>
                      </th>
                      <th>Active</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="alert in sortedActiveAlerts" :key="alert._id">
                      <td>
                        <router-link :to="{ name: 'alert edit', params: { alertId: alert._id } }" class="">
                          <template v-if="alert.title.length <= 50">
                            {{ alert.title }}
                          </template>
                          <template v-else>
                            {{ alert.title.substring(0, 50) + '...' }}
                          </template>
                        </router-link>
                      </td>
                      <td>{{ siteNames(alert.sites) }}</td>
                      <td>{{ alert.level }}</td>
                      <td>{{ alert.expires | dateOnly('Never') }}</td>
                      <td class="active">
                        <b-form-checkbox v-model="alert.isActive" @input="setActiveStatus(alert, $event)" switch>Active</b-form-checkbox>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </b-card>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12 mt-5">
          <b-card>
            <div class="inactive-alerts-section text-left">
              <h1>Inactive Alerts</h1>
              <div class="text-center mb-2 sort-wrapper">
                <span>
                  Sorting By:
                  <b>{{ inactiveCurrentSort }}</b
                  >, Sort Direction:
                  <b>{{ inactiveCurrentSortDir }}</b>
                </span>
              </div>
              <div class="table-responsive">
                <table id="inactiveAlerts" class="table table-sm table-striped">
                  <thead>
                    <tr>
                      <th @click="sort('title', (type = 'inactive'))" class="sort">
                        <span>Title<font-awesome-icon icon="sort" /></span>
                      </th>
                      <th>Property</th>
                      <th @click="sort('level', (type = 'inactive'))" class="sort">
                        <span>Level<font-awesome-icon icon="sort" /></span>
                      </th>
                      <th @click="sort('expires', (type = 'inactive'))" class="sort">
                        <span>Expires<font-awesome-icon icon="sort" /></span>
                      </th>
                      <th>Active</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="alert in sortedInactiveAlerts" :key="alert._id">
                      <td>
                        <router-link :to="{ name: 'alert edit', params: { alertId: alert._id } }" class="">
                          <template v-if="alert.title.length <= 50">
                            {{ alert.title }}
                          </template>
                          <template v-else>
                            {{ alert.title.substring(0, 50) + '...' }}
                          </template>
                        </router-link>
                      </td>
                      <td>{{ siteNames(alert.sites) }}</td>
                      <td>{{ alert.level }}</td>
                      <td>{{ alert.expires | dateOnly('Never') }}</td>
                      <td class="active">
                        <b-form-checkbox v-model="alert.isActive" @input="setActiveStatus(alert, $event)" switch>Active</b-form-checkbox>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </b-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import Loading from 'vue-loading-overlay';
import BreadcrumbsHelper from '../common/BreadcrumbsHelper.vue';

export default {
  components: {
    Loading,
    BreadcrumbsHelper,
  },
  data() {
    return {
      isLoading: false,
      alerts: [],
      activeCurrentSort: 'title',
      activeCurrentSortDir: 'asc',
      inactiveCurrentSort: 'title',
      inactiveCurrentSortDir: 'asc',
      Breadcrumbs: [
        {
          text: 'Dashboard',
          href: '/admin',
          active: false,
        },
        {
          text: 'Settings',
          active: true,
        },
        {
          text: 'Alert Notifications',
          href: '/alerts',
          active: true,
        },
      ],
    };
  },
  computed: {
    sortedActiveAlerts() {
      const activeAlerts = this.alerts.filter(alert => alert.isActive === true);
      return activeAlerts.sort((a, b) => {
        let modifier = 1;
        if (this.activeCurrentSortDir === 'desc') modifier = -1;
        if (a[this.activeCurrentSort] < b[this.activeCurrentSort]) return -1 * modifier;
        if (a[this.activeCurrentSort] > b[this.activeCurrentSort]) return 1 * modifier;
        return 0;
      });
    },
    sortedInactiveAlerts() {
      const inactiveAlerts = this.alerts.filter(alert => alert.isActive === false);
      return inactiveAlerts.sort((a, b) => {
        let modifier = 1;
        if (this.inactiveCurrentSortDir === 'desc') modifier = -1;
        if (a[this.inactiveCurrentSort] < b[this.inactiveCurrentSort]) return -1 * modifier;
        if (a[this.inactiveCurrentSort] > b[this.inactiveCurrentSort]) return 1 * modifier;
        return 0;
      });
    },
  },
  async created() {
    try {
      this.isLoading = true;
      await Promise.all([this.getAlerts()]);
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log(err);
    } finally {
      this.isLoading = false;
    }
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  methods: {
    async getAlerts() {
      const alertsResponse = await axios.get(`${process.env.VUE_APP_CRISIS_API2}`);
      this.alerts = alertsResponse.data;
    },
    async setActiveStatus(alert, e) {
      try {
        const response = await axios.get(`${process.env.VUE_APP_CRISIS_API2}/updateActiveStatus/${alert._id}/${e}`);
        this.$bvToast.toast(`${response.data}`, {
          title: 'Success',
          autoHideDelay: 5000,
          appendToast: true,
        });
      } catch (err) {
        this.$bvToast.toast('Alert Active Status Not Updated', {
          title: 'Error',
          autoHideDelay: 5000,
          appendToast: true,
        });
      }
    },
    siteNames(sites) {
      const keys = Object.keys(sites)
        .filter(k => sites[k])
        .join(', ');
      return keys;
    },
    createAlert(event) {
      console.log(event);
    },
    sort(s, type) {
      console.log('s', s);
      console.log('type :', type);
      if (type === 'active') {
        if (s === this.activeCurrentSort) {
          this.activeCurrentSortDir = this.activeCurrentSortDir === 'asc' ? 'desc' : 'asc';
        }
        this.activeCurrentSort = s;
      } else {
        if (s === this.inactiveCurrentSort) {
          this.inactiveCurrentSortDir = this.inactiveCurrentSortDir === 'asc' ? 'desc' : 'asc';
        }
        this.inactiveCurrentSort = s;
      }
    },
  },
};
</script>

<style scoped>
.card {
  border: none;
}
.card-body h1 {
  margin: 0px !important;
  line-height: 4rem;
}
table {
  overflow: hidden !important;
}
.card-body h1 {
  margin: 0px 0 10px 0;
}
.table-sm td {
  padding: 0.75rem;
}
td div {
  max-height: 165px !important;
  overflow: hidden !important;
}
table thead th {
  white-space: nowrap;
}

.sort-wrapper span {
  background-color: #f5ecca;
  padding: 5px 10px;
  border-radius: var(--rounded-md);
  margin-bottom: 5px;
  display: inline-block;
}
th.sort span {
  cursor: pointer;
}
.fa-sort {
  color: #ccc;
}
</style>
